
<div class="desktop">
    <app-banner-app [retroSelected]="false"></app-banner-app>
</div>
<br><br><br><br><br><br>

<div class="img-container">
    <img src="./assets/img/Loader_1024x576_alfa_1.gif" width="600" height="300">
</div>
<div class="mensajeLoading img-container">
    Estamos consultando tus datos...
</div>
